<div class="grid-container full-height full v-pad" id="editLetter">
    <div class="user-form-max-width">
        <h2>Editor</h2>
        <div>
            <div [froalaEditor]="froalaOptions" [(ngModel)]="coreReviewModel.currentReview.letter.htmlContent"> </div>
        </div>
        <button class="back-link vertical-middle button hollow minor-margin-right" (click)="saveLetter()" type="button">
            Save Changes
        </button>
    </div>
</div>
